import React from "react";
import { Layout, Dropdown, Menu, Button } from "antd";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { ArrowLeftOutlined, MoreOutlined } from "@ant-design/icons";
import ActionBarButton from "./ActionBarButton";
import "./styles.css";

const { Content } = Layout;

const ActionBar = ({ actionButtonProp, showBackButton = true, backTo }) => {
  const { title, arrActions, buttons } = actionButtonProp || {};
  const history = useHistory();

  const handleBack = () => {
    if (backTo) {
      history.push(backTo);
    } else {
      history.goBack();
    }
  };

  // Create dropdown menu for mobile (AntD Menu items API)
  const mobileMenuItems = (arrActions || []).map((action, index) => ({
    key: String(index),
    label: (
      <span onClick={action.btnAction}>
        {action.btnName}
      </span>
    ),
  }));

  return (
    <div className="ActionBar">
      <div className="ActionBar-wrapper">
        <div className="ActionBar-left">
          {showBackButton && (
            <button onClick={handleBack} className="ActionBar-backButton">
              <ArrowLeftOutlined />
              <span className="ActionBar-backButton-text">Back</span>
            </button>
          )}

          <Content className="ActionBar-title-container">
            <h1 className="ActionBar-title">{title}</h1>
          </Content>
        </div>

        {/* Desktop buttons */}
        <div className="ActionBar-buttons-desktop">
          {/* Custom buttons passed through actionButtonProp */}
          {buttons}

          {/* Existing arrActions buttons */}
          {arrActions && (
            <>
              {arrActions.map((arrAction) => (
                <ActionBarButton
                  datatestid={arrAction?.datatestid}
                  key={arrAction.btnName}
                  btnName={arrAction.btnName}
                  btnAction={arrAction.btnAction}
                  btnType={arrAction?.btnType}
                />
              ))}
            </>
          )}
        </div>

        {/* Mobile dropdown menu */}
        {(buttons || arrActions) && (
          <div className="ActionBar-buttons-mobile">
            {buttons}
            {arrActions && arrActions.length > 0 && (
              <Dropdown overlay={<Menu items={mobileMenuItems} />} placement="bottomRight">
                <Button icon={<MoreOutlined />} />
              </Dropdown>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ActionBar;
